import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OperationType } from 'common/constants/sm-constants';
import { DashboardModel } from 'common/models/page-models/dashboard/dashboard-data-model';
import { DashboardListingModel } from 'common/models/page-models/dashboard/dashboard-grid-model';
import { RouteEnvelope } from 'common/models/utility-models/base-model';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { DashboardWidgetService } from 'common/widget/dashboard/dashboard-widget.service';

@Injectable({
    providedIn: 'root'
})
export class DashboardResolver extends GridResolver<DashboardModel, DashboardListingModel> {
    constructor(
        protected fs: DashboardWidgetService,
        protected override  router: Router,
        protected override  systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override manageState() {
        if (this.router.getCurrentNavigation().extras.state === undefined) {
            const envelope = new RouteEnvelope();
            envelope.type = OperationType.VIEW;
            envelope.transferData = new GridParams();
            return envelope;
        } else {
            return this.router.getCurrentNavigation().extras.state;
        }

    }

    override modifyResponseData(dataModel: any, meta: any, widget: any) {
        dataModel['filterData'] = new DashboardModel();
        return dataModel;
    }
}